import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { CartoesService, ContasService, fmtMoeda, fmtData, mesAtual } from '../services';

const bandeiras = { visa: '💙 Visa', mastercard: '🔴 Mastercard', elo: '🟡 Elo', amex: '💚 Amex', hipercard: '🔵 Hipercard', outro: '💳 Outro' };

const initForm = { nome: '', bandeira: 'outro', banco: '', limite: '', dia_vencimento: 10, dia_fechamento: 3, cor: '#7c3aed', observacoes: '' };

export default function Cartoes() {
  const [cartoes, setCartoes] = useState([]);
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(initForm);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');

  // Fatura view
  const [cartaoFatura, setCartaoFatura] = useState(null);
  const [mesFatura, setMesFatura] = useState(mesAtual());
  const [dadosFatura, setDadosFatura] = useState(null);
  const [loadFatura, setLoadFatura] = useState(false);
  const [modalPagar, setModalPagar] = useState(false);
  const [pagForm, setPagForm] = useState({ conta_id: '', data_pagamento: new Date().toISOString().split('T')[0] });

  const load = () => {
    setLoading(true);
    Promise.all([CartoesService.listar(), ContasService.listar()])
      .then(([c, ct]) => { setCartoes(c); setContas(ct); })
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  useEffect(() => {
    if (!cartaoFatura) return;
    setLoadFatura(true);
    CartoesService.fatura(cartaoFatura.id, mesFatura).then(setDadosFatura).finally(() => setLoadFatura(false));
  }, [cartaoFatura, mesFatura]);

  const openNew = () => { setEditing(null); setForm(initForm); setErro(''); setModal(true); };
  const openEdit = (c) => { setEditing(c); setForm({ ...c }); setErro(''); setModal(true); };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErro('');
    try {
      if (editing) await CartoesService.atualizar(editing.id, form);
      else await CartoesService.criar(form);
      setModal(false); load();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar');
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir este cartão?')) return;
    try { await CartoesService.excluir(id); load(); }
    catch (err) { alert(err.response?.data?.erro || 'Erro'); }
  };

  const handlePagar = async (e) => {
    e.preventDefault();
    try {
      await CartoesService.pagarFatura(cartaoFatura.id, mesFatura, pagForm);
      setModalPagar(false);
      CartoesService.fatura(cartaoFatura.id, mesFatura).then(setDadosFatura);
      load();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao pagar'); }
  };

  if (cartaoFatura) return (
    <Layout title={`Fatura — ${cartaoFatura.nome}`}>
      <div className="flex-between mb-3">
        <button className="btn btn-ghost" onClick={() => { setCartaoFatura(null); setDadosFatura(null); }}>
          ← Voltar
        </button>
        <div className="month-picker">
          <input type="month" value={mesFatura} onChange={e => setMesFatura(e.target.value)} />
        </div>
        {dadosFatura?.fatura?.status !== 'paga' && dadosFatura?.fatura?.valor_total > 0 && (
          <button className="btn btn-success" onClick={() => setModalPagar(true)}>💰 Pagar Fatura</button>
        )}
      </div>

      {loadFatura ? <div className="loading-wrap"><div className="spinner" /></div> : dadosFatura && (
        <>
          <div className="stat-grid" style={{ marginBottom: 20 }}>
            <div className="stat-card">
              <span className="stat-label">Total da Fatura</span>
              <span className="stat-value" style={{ fontSize: 22, color: 'var(--danger)' }}>{fmtMoeda(dadosFatura.fatura.valor_total)}</span>
            </div>
            <div className="stat-card">
              <span className="stat-label">Vencimento</span>
              <span className="stat-value" style={{ fontSize: 18 }}>{fmtData(dadosFatura.fatura.data_vencimento)}</span>
            </div>
            <div className="stat-card">
              <span className="stat-label">Status</span>
              <span className={`badge ${dadosFatura.fatura.status === 'paga' ? 'badge-success' : dadosFatura.fatura.status === 'fechada' ? 'badge-warning' : 'badge-primary'}`}
                style={{ marginTop: 6, fontSize: 13 }}>
                {dadosFatura.fatura.status.toUpperCase()}
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-header"><span className="card-title">Lançamentos da fatura</span></div>
            {dadosFatura.transacoes.length === 0 ? (
              <div className="empty-state"><p>Nenhum lançamento nesta fatura</p></div>
            ) : (
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Descrição</th><th>Categoria</th><th>Data</th><th>Valor</th></tr></thead>
                  <tbody>
                    {dadosFatura.transacoes.map(t => (
                      <tr key={t.id}>
                        <td style={{ fontWeight: 500, fontSize: 13 }}>{t.descricao}</td>
                        <td style={{ fontSize: 13 }}>{t.categoria_icone} {t.categoria_nome || '—'}</td>
                        <td style={{ fontSize: 13 }}>{fmtData(t.data)}</td>
                        <td className="value-negative">{fmtMoeda(t.valor)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}

      {modalPagar && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModalPagar(false)}>
          <div className="modal modal-sm">
            <div className="modal-header">
              <span className="modal-title">Pagar Fatura</span>
              <button className="modal-close" onClick={() => setModalPagar(false)}>×</button>
            </div>
            <form onSubmit={handlePagar}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Total a pagar</label>
                  <div style={{ fontWeight: 700, fontSize: 20, color: 'var(--danger)' }}>{fmtMoeda(dadosFatura?.fatura?.valor_total)}</div>
                </div>
                <div className="form-group">
                  <label className="form-label">Debitar da conta</label>
                  <select className="form-control" value={pagForm.conta_id} onChange={e => setPagForm(p => ({ ...p, conta_id: e.target.value }))}>
                    <option value="">Não debitar</option>
                    {contas.map(c => <option key={c.id} value={c.id}>{c.icone} {c.nome}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Data do pagamento</label>
                  <input type="date" className="form-control" value={pagForm.data_pagamento}
                    onChange={e => setPagForm(p => ({ ...p, data_pagamento: e.target.value }))} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost" onClick={() => setModalPagar(false)}>Cancelar</button>
                <button type="submit" className="btn btn-success">Confirmar Pagamento</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );

  return (
    <Layout title="Cartões de Crédito">
      <div className="flex-between mb-3">
        <p style={{ color: 'var(--gray-500)', fontSize: 13 }}>{cartoes.length} cartão(s) cadastrado(s)</p>
        <button className="btn btn-primary" onClick={openNew}>+ Novo Cartão</button>
      </div>

      {loading ? (
        <div className="loading-wrap"><div className="spinner" /></div>
      ) : cartoes.length === 0 ? (
        <div className="empty-state card">
          <div className="empty-icon">💳</div>
          <p>Nenhum cartão cadastrado.</p>
          <button className="btn btn-primary mt-2" onClick={openNew}>Adicionar cartão</button>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
          {cartoes.map(c => {
            const usado = parseFloat(c.limite) - parseFloat(c.limite_disponivel);
            const pct = Math.min(100, (usado / parseFloat(c.limite)) * 100);
            return (
              <div key={c.id} className="card">
                <div className="credit-card-visual" style={{ background: `linear-gradient(135deg, ${c.cor}, ${c.cor}88)` }}>
                  <div>
                    <div style={{ fontSize: 11, opacity: .8 }}>{bandeiras[c.bandeira]}</div>
                    <div style={{ fontWeight: 700, fontSize: 17, marginTop: 4 }}>{c.nome}</div>
                    {c.banco && <div style={{ fontSize: 12, opacity: .7 }}>{c.banco}</div>}
                  </div>
                  <div>
                    <div style={{ fontSize: 10, opacity: .7 }}>Limite utilizado</div>
                    <div style={{ fontWeight: 700, fontSize: 22 }}>{fmtMoeda(usado)}</div>
                    <div style={{ background: 'rgba(255,255,255,.2)', borderRadius: 100, height: 5, margin: '6px 0' }}>
                      <div style={{ width: `${pct}%`, background: pct > 80 ? '#fca5a5' : 'white', height: 5, borderRadius: 100 }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, opacity: .8 }}>
                      <span>Disponível: {fmtMoeda(c.limite_disponivel)}</span>
                      <span>Limite: {fmtMoeda(c.limite)}</span>
                    </div>
                    <div style={{ marginTop: 8, fontSize: 11, opacity: .7 }}>
                      Fecha dia {c.dia_fechamento} · Vence dia {c.dia_vencimento}
                    </div>
                  </div>
                </div>
                <div style={{ padding: '12px 16px', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <button className="btn btn-primary btn-sm" onClick={() => setCartaoFatura(c)}>📄 Ver Fatura</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => openEdit(c)}>✏️ Editar</button>
                  <button className="btn btn-ghost btn-sm" style={{ color: 'var(--danger)' }} onClick={() => handleDelete(c.id)}>🗑️</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal modal-md">
            <div className="modal-header">
              <span className="modal-title">{editing ? 'Editar Cartão' : 'Novo Cartão'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="modal-body">
                {erro && <div className="alert alert-danger">{erro}</div>}
                <div className="form-grid">
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="form-label">Nome do cartão *</label>
                    <input className="form-control" required value={form.nome}
                      onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Bandeira</label>
                    <select className="form-control" value={form.bandeira} onChange={e => setForm(p => ({ ...p, bandeira: e.target.value }))}>
                      {Object.entries(bandeiras).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Banco / Emissor</label>
                    <input className="form-control" value={form.banco || ''} placeholder="Ex: Nubank..."
                      onChange={e => setForm(p => ({ ...p, banco: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Limite (R$) *</label>
                    <input type="number" step="0.01" className="form-control" required value={form.limite}
                      onChange={e => setForm(p => ({ ...p, limite: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Dia de vencimento</label>
                    <input type="number" min="1" max="31" className="form-control" value={form.dia_vencimento}
                      onChange={e => setForm(p => ({ ...p, dia_vencimento: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Dia de fechamento</label>
                    <input type="number" min="1" max="31" className="form-control" value={form.dia_fechamento}
                      onChange={e => setForm(p => ({ ...p, dia_fechamento: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Cor</label>
                    <input type="color" className="form-control" value={form.cor} style={{ height: 40, padding: 4 }}
                      onChange={e => setForm(p => ({ ...p, cor: e.target.value }))} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
